import React, { Component } from 'react'
import LocationSearchContainer from '../location-search/LocationSearchContainer'
import LinkPopup from '../common/LinkPopup'

export const PanelLocation = ({ location }) => {
  return (
    <>
      <div className="HeaderSection">
        <h5 className="HeaderSection-heading">Location</h5>
        <LinkPopup linkText="Change Location">
          <LocationSearchContainer />
        </LinkPopup>
      </div>
      {location && <ChangeLocationPanel location={location} />}
    </>
  )
}

export class ChangeLocationPanel extends Component {
  constructor(props) {
    super(props)
    this.state = { showModal: false }
    this.showModal = this.showModal.bind(this)
    this.hideModal = this.hideModal.bind(this)
  }

  showModal() {
    this.setState({ showModal: true })
  }

  hideModal() {
    this.setState({ showModal: false })
  }

  render() {
    const {
      location: { deliveryLocationName, street },
    } = this.props
    return (
      <div className="row">
        <div className="col-xs-12">
          <p>{deliveryLocationName}</p>
          <p>{street}</p>
        </div>
      </div>
    )
  }
}

export default PanelLocation
